"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineSegmentAttach = void 0;
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const boundingBox_1 = require("../boundingBox");
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const GeometrySnapper_js_1 = __importDefault(require("jsts/org/locationtech/jts/operation/overlay/snap/GeometrySnapper.js"));
const GeometryFactory_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/GeometryFactory.js"));
const tolerance = 30;
class LineSegmentAttach {
    compute(lines) {
        const factory = new GeometryFactory_js_1.default();
        let lineStringArr = new Array();
        let boundingBoxes = new Array();
        for (let line of lines) {
            let coords = [new Coordinate_js_1.default(line[0].x, line[0].y), new Coordinate_js_1.default(line[1].x, line[1].y)];
            let lineString = factory.createLineString(coords);
            lineStringArr.push(lineString);
            let boundingBox = new boundingBox_1.BoundingBox(coords);
            boundingBoxes.push(boundingBox);
        }
        for (let i = lineStringArr.length - 1; i > 0; i--) {
            for (let j = i - 1; j >= 0; j--) {
                if (boundingBoxes[i].intersectTolerance(boundingBoxes[j], tolerance)) { //带有容差值的包围盒相交判断，加快效率。但是由于包围盒没有随着Snap更新，所以有可能会有问题。目前没有问题，暂时先不管
                    let snapResult = GeometrySnapper_js_1.default.snap(lineStringArr[i], lineStringArr[j], tolerance);
                    lineStringArr[i] = snapResult[0];
                    lineStringArr[j] = snapResult[1];
                }
            }
        }
        let newLines = new Array();
        for (let lineString of lineStringArr) {
            let points = lineString.getCoordinates();
            for (let i = 0; i < points.length - 1; i++) {
                newLines.push([new ltpoint_1.LTPoint(points[i].x, points[i].y), new ltpoint_1.LTPoint(points[i + 1].x, points[i + 1].y)]);
            }
        }
        return newLines;
    }
}
exports.LineSegmentAttach = LineSegmentAttach;
